export function safeNumber(value: string | number | undefined | null) {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    Number.isNaN(+formatTextNumber(String(value)))
  ) {
    return 0;
  }
  return +formatTextNumber(String(value));
}

export function formatTextNumber(value: string) {
  return value
    .replace(",", ".")
    .replace(/[^0-9.]/g, "")
    .replace(/(\..*)\./g, "$1");
}
